export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20modern%20living%20room%20interior%20at%20golden%20hour%20sunset%2C%20a%20young%20Asian%20couple%20sitting%20comfortably%20on%20a%20plush%20beige%20sofa%20watching%20a%20large%20TV%20screen%20together%2C%20soft%20ambient%20lighting%20from%20a%20warm%20floor%20lamp%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20style%2C%20warm%20terracotta%20and%20cream%20tones%20with%20soft%20shadows%2C%20intimate%20and%20romantic%20mood%2C%20clean%20aesthetic%20with%20neutral%20beige%20and%20golden%20accents%2C%20high%20detail%2C%20harmonious%20composition&width=1920&height=1080&seq=hero-bg-2026-couple&orientation=landscape"
          alt="情侣在温馨的客厅一起追剧"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-0">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-sm font-medium mb-6 backdrop-blur-sm">
              电视剧全集 · 最新电视剧免费在线看
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
              情侣影院
              <span className="block text-xl md:text-2xl lg:text-3xl font-normal text-white/80 mt-2">
                和另一半窝在一起，追完每一部好剧
              </span>
            </h1>

            <p className="text-white/75 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              情侣影院是国内领先的情侣追剧平台，收录国产剧全集和韩剧全集，每日同步更新最新电视剧。
              无论是热播的甜宠国产剧，还是高分经典的韩剧全集，都能在这里找到高清片源，和你的另一半窝在沙发上轻松追剧。
              我们坚持免费在线观看，无需注册即可畅享高清画质，让每一对情侣都能拥有专属的追剧时光。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-400">2000+</div>
                <div className="text-xs text-white/55 mt-1">电视剧全集收录</div>
              </div>
              <div className="w-px h-8 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-400">每日更新</div>
                <div className="text-xs text-white/55 mt-1">同步最新剧集</div>
              </div>
              <div className="w-px h-8 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-400">1080P</div>
                <div className="text-xs text-white/55 mt-1">全高清免费看</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors"
              >
                <i className="ri-fire-line text-lg"></i>
                立即追剧
              </a>
              <a
                href="#features"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none hidden lg:block">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20cinematic%20scene%20of%20a%20couple%20cuddled%20under%20a%20soft%20blanket%20on%20a%20cozy%20sofa%2C%20warm%20golden%20sunset%20light%20streaming%20through%20a%20window%2C%20a%20glowing%20TV%20screen%20in%20front%20of%20them%20showing%20colorful%20abstract%20bokeh%20lights%2C%20romantic%20intimate%20atmosphere%2C%20soft%20focus%20edges%2C%20editorial%20film%20photography%2C%20warm%20terracotta%20and%20cream%20tones%2C%20dreamy%20cinematic%20mood%2C%20high%20quality&width=800&height=1000&seq=hero-visual-couple-tv&orientation=portrait"
                alt="情侣依偎在沙发上看电视剧的温馨场景"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}